import { useUsername, useUsernameCacheLoading } from '../services/usernameCache';
import { Link } from 'react-router-dom';
import { memo } from 'react';

interface PlayerProfileProps {
  uuid: string;
  name?: string;
  showUuid?: boolean;
  showAvatar?: boolean;
  nickname?: string;
  ipAddress?: string;
  inline?: boolean;
}

export const PlayerProfile = memo(({ uuid, name, showUuid = true, showAvatar = true, nickname, ipAddress, inline = false }: PlayerProfileProps) => {
  const fetchedName = useUsername(uuid);
  const isLoading = useUsernameCacheLoading();
  const displayName = name || nickname || fetchedName || uuid;
  const isFetchingName = isLoading && !name && !nickname && !fetchedName;

  const isDev = import.meta.env.DEV;
  const avatarUrl = isDev
    ? `https://spy.playcdu.co/cdu-heads/avatar/${uuid}/32.png`
    : `/cdu-heads/avatar/${uuid}/32.png`;

  if (inline) {
    return (
      <Link to={`/player/${uuid}`} className="inline-flex items-center gap-1.5 group align-middle max-w-full min-w-0">
        {showAvatar && <img src={avatarUrl} alt="" className="w-4 h-4 rounded-[3px] flex-shrink-0" />}
        <span className="text-white font-medium group-hover:text-accent-300 transition-colors truncate">{isFetchingName ? 'Loading...' : displayName}</span>
      </Link>
    )
  }

  return (
    <Link to={`/player/${uuid}`} className="flex items-center gap-2.5 group w-full min-w-0">
      {showAvatar && <img src={avatarUrl} alt="" className="w-8 h-8 rounded-md flex-shrink-0 ring-1 ring-glass-200/15" />}
      <div className="flex-1 overflow-hidden min-w-0">
        <div className="flex items-baseline gap-2 min-w-0">
            <span className="text-white font-medium group-hover:text-accent-300 transition-colors truncate">{isFetchingName ? 'Loading...' : displayName}</span>
            {nickname && nickname !== displayName && (
                <span className="text-glass-400 text-xs truncate">({nickname})</span>
            )}
        </div>
        <div className="flex flex-col items-start">
            {showUuid && <span className="text-[11px] text-glass-400 font-mono truncate max-w-full">{uuid}</span>}
            {ipAddress && <span className="text-[11px] text-yellow-400 font-mono truncate">IP: {ipAddress}</span>}
        </div>
      </div>
    </Link>
  );
});
